import {ChangeDetectionStrategy, Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {Observable} from 'rxjs';
import {Filter, PagedResponse, Battery, DevicesClient, GetBatteries, ObservedDataSource} from 'shared';
import {NgrxBusy} from 'ngrx-busy';

@Component({
  selector: 'app-batteries',
  templateUrl: './batteries.component.html',
  styleUrls: ['./batteries.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BatteriesComponent implements OnInit {
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(Filter, {static: true}) filter: Filter;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(NgrxBusy, {static: true}) busy: NgrxBusy;

  dataSource: FlashlightDataSource;
  columns = ['id', 'serial', 'create_date'];

  constructor(private devicesClient: DevicesClient) {
    this.dataSource = new FlashlightDataSource(devicesClient);
  }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.filter = this.filter;
    this.dataSource.paginator = this.paginator;
    this.dataSource.busy = this.busy;
  }
}

class FlashlightDataSource extends ObservedDataSource<Battery, GetBatteries> {
  constructor(private devicesClient: DevicesClient) {
    super(device => device.id);
  }

  source(query: Partial<GetBatteries>): Observable<PagedResponse<Battery>> {
    return this.devicesClient.getBatteries(new GetBatteries(query));
  }
}
